export const employees = [
    {
        employeeId: "EMP001",
        firstName: "John",
        lastName: "Doe",
        middleName: "Robert",
        fullName: "John Robert Doe",
        gender: "Male",
        dateOfBirth: "1990-05-15",
        age: 33,
        civilStatus: "Married",
        contactNumber: "+1 (555) 123-4567",
        email: "john.doe@company.com",
        currentAddress: "123 Main St, Anytown, ST 12345",
        permanentAddress: "123 Main St, Anytown, ST 12345",
        nationality: "American",
        emergencyName: "Jane Doe",
        emergencyNumber: "+1 (555) 987-6543",
        emergencyRelation: "Spouse",
        dateHired: "2020-03-15",
        dateRegularized: "2020-09-15",
        employmentStatus: "Regular",
        workArrangement: "Hybrid",
        companyName: "Tech Solutions Inc.",
        businessUnit: "Technology",
        department: "Engineering",
        position: "Senior Software Engineer",
        reportingManager: "Sarah Wilson",
        employeeType: "Full-time",
        endDate: null,
        terminationReason: null,
        lengthOfService: "3 years 2 months",
        basicSalary: 75000,
        salaryType: "Monthly",
        payFrequency: "Semi-Monthly",
        hourlyRate: 4912.43,
        dailyRate: 3571.43,
        monthlyRate: 75000,
        annualSalary: 900000,
        overtimePay: 0,
        nightDifferential: 0,
        holidayPay: 0,
        restDayPay: 0,
        hazardPay: 0,
        otherEarnings: 5000,
        grossPay: 80000,
        taxableIncome: 75000,
        withHoldingTax: 15000,
        netPay: 65000,
        thirteenthMonth: 75000,
        bonus: 150000,
        loanDeduction: 5000,
        advancesDeduction: 0,
        otherDeductions: 2000,
        totalLeaveBalance: 40,
        leaveTypeBreakdown: {
            "Sick Leave": 10,
            "Vacation Leave": 10,
            "Leave Type 3": 10,
            "Leave Type 4": 10,
        },
        totalLeaveBalanceTransactions: [
            {
                date: "2024-03-01",
                type: "Credit",
                amount: "+15",
                balance: "32.5",
            },
            {
                date: "2024-02-15",
                type: "Debit",
                amount: "-5",
                balance: "10",
            },
            {
                date: "2024-01-01",
                type: "Credit",
                amount: "+15",
                balance: "15",
            },
        ],
        totalLeaveTransactions: [
            {
                id: "TRX001",
                date: "2024-03-15",
                type: "Credit",
                leaveType: "Annual Leave",
                description: "Monthly accrual",
                amount: 1.67,
                balance: 41.67,
                status: "Completed",
                approvedBy: "System",
                requestDate: "2024-03-01",
            },
            {
                id: "TRX002",
                date: "2024-03-10",
                type: "Debit",
                leaveType: "Sick Leave",
                description: "Medical appointment",
                amount: -1,
                balance: 40,
                status: "Approved",
                approvedBy: "Sarah Wilson",
                requestDate: "2024-03-05",
            },
            {
                id: "TRX003",
                date: "2024-02-15",
                type: "Credit",
                leaveType: "Annual Leave",
                description: "Monthly accrual",
                amount: 1.67,
                balance: 41,
                status: "Completed",
                approvedBy: "System",
                requestDate: "2024-02-01",
            },
            {
                id: "TRX004",
                date: "2024-02-05",
                type: "Debit",
                leaveType: "Annual Leave",
                description: "Family vacation",
                amount: -5,
                balance: 39.33,
                status: "Approved",
                approvedBy: "Sarah Wilson",
                requestDate: "2024-01-20",
            },
        ],
        annualLeaveTransactions: [
            {
                id: "ALTRX001",
                date: "2024-03-15",
                type: "Credit",
                description: "Monthly accrual",
                amount: 1.67,
                balance: 11.67,
            },
            {
                id: "ALTRX002",
                date: "2024-02-15",
                type: "Credit",
                description: "Monthly accrual",
                amount: 1.67,
                balance: 10,
            },
            {
                id: "ALTRX003",
                date: "2024-02-05",
                type: "Debit",
                description: "Family vacation",
                amount: -5,
                balance: 8.33,
            },
        ],
        sickLeaveTransactions: [
            {
                id: "SLTRX001",
                date: "2024-03-10",
                type: "Debit",
                description: "Medical appointment",
                amount: -1,
                balance: 9,
            },
            {
                id: "SLTRX002",
                date: "2024-01-15",
                type: "Credit",
                description: "Annual reset",
                amount: 10,
                balance: 10,
            },
        ],
        sickLeaveBalance: 9.5,
        vacationLeaveBalance: 12,
        emergencyLeaveBalance: 3,
        maternityLeaveBalance: 90,
        paternityLeaveBalance: 7.5,
        bereavementLeaveBalance: 0,
        birthdayLeaveBalance: 1,
        specialLeaveBalance: 7,
        leaveType: "Maternity Leave",
        leaveStatus: "Pending",
        leaveStartDate: "2024-06-15",
        leaveEndDate: "2024-09-28",
        leaveDuration: 105,
        leaveReason: "Maternity leave for first child",
        leaveUsedYTD: 15,
        leaveRemaining: 17.5,
        leaveAccrualRate: 1.67,
        nextScheduledLeave: "2024-06-10",
        annualLeaveBalance: 13,
        annualLeaveEntitlement: 20,
        annualLeaveUsed: 10,
        annualLeaveRemaining: 10,
        annualLeaveRequested: 3,
        annualLeaveAccrued: 6,
        annualLeaveExpiry: "2024-12-31",
        sickLeaveEntitlement: 15,
        sickLeaveUsed: 5.5,
        sickLeaveRemaining: 9.5,
        sickLeaveDocumentation: true,
        sickLeaveIncidents: 3,
        maternityLeaveEntitlement: 90,
        maternityLeaveUsed: 0,
        maternityLeaveRemaining: 90,
        maternityLeaveStartDate: null,
        maternityLeaveEndDate: null,
        paternityLeaveEntitlement: 10,
        paternityLeaveUsed: 2.5,
        paternityLeaveRemaining: 7.5,
        bereavementLeaveEntitlement: 5,
        bereavementLeaveUsed: 0,
        bereavementLeaveRemaining: 5,
        pendingRequests: [
            {
                id: "REQ2001",
                type: "Annual Leave",
                startDate: "2024-06-10",
                endDate: "2024-06-12",
                days: 3,
                status: "Pending",
                requestedOn: "2024-04-15",
            },
        ],
        pendingRequestsCount: 1,
        pendingRequestsDays: 3,
        pendingRequestsEarliestDate: "2024-06-10",
        approvedRequests: [
            {
                id: "REQ1901",
                type: "Annual Leave",
                startDate: "2024-02-26",
                endDate: "2024-03-01",
                days: 5,
                status: "Approved",
                requestedOn: "2024-01-15",
                approvedOn: "2024-01-16",
                approvedBy: "Michael Brown",
            },
            {
                id: "REQ1801",
                type: "Sick Leave",
                startDate: "2024-01-08",
                endDate: "2024-01-09",
                days: 2,
                status: "Approved",
                requestedOn: "2024-01-08",
                approvedOn: "2024-01-10",
                approvedBy: "Michael Brown",
            },
        ],
        approvedRequestsCount: 2,
        approvedRequestsDays: 7,
        approvedRequestsNextDate: "2024-02-26",
        deniedRequests: [],
        deniedRequestsCount: 0,
        deniedRequestsDays: 0,
        leaveHistoryYTD: [
            {
                id: "LEAVE2001",
                type: "Annual Leave",
                startDate: "2024-02-26",
                endDate: "2024-03-01",
                days: 5,
                status: "Completed",
            },
            {
                id: "LEAVE2002",
                type: "Sick Leave",
                startDate: "2024-01-08",
                endDate: "2024-01-09",
                days: 2,
                status: "Completed",
            },
            {
                id: "LEAVE2003",
                type: "Sick Leave",
                startDate: "2024-03-15",
                endDate: "2024-03-16",
                days: 1.5,
                status: "Completed",
                note: "Half day on the second day",
            },
        ],
        leaveHistoryYTDDays: 8.5,
        leaveHistoryYTDIncidents: 3,
        leaveHistoryYTDLongest: 5,
        leaveHistoryPrevYear: [
            {
                id: "LEAVE1901",
                type: "Annual Leave",
                startDate: "2023-08-21",
                endDate: "2023-09-01",
                days: 10,
                status: "Completed",
            },
            {
                id: "LEAVE1902",
                type: "Sick Leave",
                startDate: "2023-10-12",
                endDate: "2023-10-16",
                days: 5,
                status: "Completed",
            },
        ],
        leaveHistoryPrevYearDays: 15,
        leaveHistoryPrevYearIncidents: 2,
        leaveBreakdown: {
            "Annual Leave": 7,
            "Sick Leave": 3,
            "Paternity Leave": 2.5,
        },
    },
    {
        employeeId: "EMP002",
        firstName: "Maria",
        lastName: "Garcia",
        middleName: "Elena",
        fullName: "Maria Elena Garcia",
        gender: "Female",
        dateOfBirth: "1988-09-23",
        age: 35,
        civilStatus: "Single",
        contactNumber: "+1 (555) 234-5678",
        email: "maria.garcia@company.com",
        currentAddress: "456 Oak Ave, Somewhere, ST 67890",
        permanentAddress: "456 Oak Ave, Somewhere, ST 67890",
        nationality: "Spanish",
        emergencyName: "Carlos Garcia",
        emergencyNumber: "+1 (555) 876-5432",
        emergencyRelation: "Father",
        dateHired: "2019-06-01",
        dateRegularized: "2019-12-01",
        employmentStatus: "Regular",
        workArrangement: "Remote",
        companyName: "Tech Solutions Inc.",
        businessUnit: "Operations",
        department: "Human Resources",
        position: "HR Manager",
        reportingManager: "Michael Brown",
        employeeType: "Full-time",
        endDate: null,
        terminationReason: null,
        lengthOfService: "4 years 7 months",
        basicSalary: 75000,
        salaryType: "Monthly",
        payFrequency: "Semi-Monthly",
        hourlyRate: 446.43,
        dailyRate: 3571.43,
        monthlyRate: 75000,
        annualSalary: 900000,
        overtimePay: 0,
        nightDifferential: 0,
        holidayPay: 0,
        restDayPay: 0,
        hazardPay: 0,
        otherEarnings: 5000,
        grossPay: 80000,
        taxableIncome: 75000,
        withHoldingTax: 15000,
        netPay: 65000,
        thirteenthMonth: 75000,
        bonus: 150000,
        loanDeduction: 5000,
        advancesDeduction: 0,
        otherDeductions: 2000,
        totalLeaveBalance: 40,
        leaveTypeBreakdown: {
            "Sick Leave": 10,
            "Vacation Leave": 10,
            "Leave Type 3": 10,
            "Leave Type 4": 10,
        },
        totalLeaveBalanceTransactions: [
            {
                date: "2024-03-01",
                type: "Credit",
                amount: "+15",
                balance: "32.5",
            },
            {
                date: "2024-02-15",
                type: "Debit",
                amount: "-5",
                balance: "10",
            },
            {
                date: "2024-01-01",
                type: "Credit",
                amount: "+15",
                balance: "15",
            },
        ],
        totalLeaveTransactions: [
            {
                id: "TRX001",
                date: "2024-03-15",
                type: "Credit",
                leaveType: "Annual Leave",
                description: "Monthly accrual",
                amount: 1.67,
                balance: 41.67,
                status: "Completed",
                approvedBy: "System",
                requestDate: "2024-03-01",
            },
            {
                id: "TRX002",
                date: "2024-03-10",
                type: "Debit",
                leaveType: "Sick Leave",
                description: "Medical appointment",
                amount: -1,
                balance: 40,
                status: "Approved",
                approvedBy: "Sarah Wilson",
                requestDate: "2024-03-05",
            },
            {
                id: "TRX003",
                date: "2024-02-15",
                type: "Credit",
                leaveType: "Annual Leave",
                description: "Monthly accrual",
                amount: 1.67,
                balance: 41,
                status: "Completed",
                approvedBy: "System",
                requestDate: "2024-02-01",
            },
            {
                id: "TRX004",
                date: "2024-02-05",
                type: "Debit",
                leaveType: "Annual Leave",
                description: "Family vacation",
                amount: -5,
                balance: 39.33,
                status: "Approved",
                approvedBy: "Sarah Wilson",
                requestDate: "2024-01-20",
            },
        ],
        annualLeaveTransactions: [
            {
                id: "ALTRX001",
                date: "2024-03-15",
                type: "Credit",
                description: "Monthly accrual",
                amount: 1.67,
                balance: 11.67,
            },
            {
                id: "ALTRX002",
                date: "2024-02-15",
                type: "Credit",
                description: "Monthly accrual",
                amount: 1.67,
                balance: 10,
            },
            {
                id: "ALTRX003",
                date: "2024-02-05",
                type: "Debit",
                description: "Family vacation",
                amount: -5,
                balance: 8.33,
            },
        ],
        sickLeaveTransactions: [
            {
                id: "SLTRX001",
                date: "2024-03-10",
                type: "Debit",
                description: "Medical appointment",
                amount: -1,
                balance: 9,
            },
            {
                id: "SLTRX002",
                date: "2024-01-15",
                type: "Credit",
                description: "Annual reset",
                amount: 10,
                balance: 10,
            },
        ],
        sickLeaveBalance: 9.5,
        vacationLeaveBalance: 12,
        emergencyLeaveBalance: 3,
        maternityLeaveBalance: 90,
        paternityLeaveBalance: 0,
        bereavementLeaveBalance: 5,
        birthdayLeaveBalance: 1,
        specialLeaveBalance: 7,
        leaveType: "Maternity Leave",
        leaveStatus: "Pending",
        leaveStartDate: "2024-06-15",
        leaveEndDate: "2024-09-28",
        leaveDuration: 105,
        leaveReason: "Maternity leave for first child",
        leaveUsedYTD: 15,
        leaveRemaining: 17.5,
        leaveAccrualRate: 1.67,
        nextScheduledLeave: "2024-06-10",
        annualLeaveBalance: 13,
        annualLeaveEntitlement: 20,
        annualLeaveUsed: 10,
        annualLeaveRemaining: 10,
        annualLeaveRequested: 3,
        annualLeaveAccrued: 6,
        annualLeaveExpiry: "2024-12-31",
        sickLeaveEntitlement: 15,
        sickLeaveUsed: 5.5,
        sickLeaveRemaining: 9.5,
        sickLeaveDocumentation: true,
        sickLeaveIncidents: 3,
        maternityLeaveEntitlement: 90,
        maternityLeaveUsed: 0,
        maternityLeaveRemaining: 90,
        maternityLeaveStartDate: null,
        maternityLeaveEndDate: null,
        paternityLeaveEntitlement: 0,
        paternityLeaveUsed: 0,
        paternityLeaveRemaining: 0,
        bereavementLeaveEntitlement: 5,
        bereavementLeaveUsed: 0,
        bereavementLeaveRemaining: 5,
        pendingRequests: [
            {
                id: "REQ2001",
                type: "Annual Leave",
                startDate: "2024-06-10",
                endDate: "2024-06-12",
                days: 3,
                status: "Pending",
                requestedOn: "2024-04-15",
            },
        ],
        pendingRequestsCount: 1,
        pendingRequestsDays: 3,
        pendingRequestsEarliestDate: "2024-06-10",
        approvedRequests: [
            {
                id: "REQ1901",
                type: "Annual Leave",
                startDate: "2024-02-26",
                endDate: "2024-03-01",
                days: 5,
                status: "Approved",
                requestedOn: "2024-01-15",
                approvedOn: "2024-01-16",
                approvedBy: "Michael Brown",
            },
            {
                id: "REQ1801",
                type: "Sick Leave",
                startDate: "2024-01-08",
                endDate: "2024-01-09",
                days: 2,
                status: "Approved",
                requestedOn: "2024-01-08",
                approvedOn: "2024-01-10",
                approvedBy: "Michael Brown",
            },
        ],
        approvedRequestsCount: 2,
        approvedRequestsDays: 7,
        approvedRequestsNextDate: "2024-02-26",
        deniedRequests: [],
        deniedRequestsCount: 0,
        deniedRequestsDays: 0,
        leaveHistoryYTD: [
            {
                id: "LEAVE2001",
                type: "Annual Leave",
                startDate: "2024-02-26",
                endDate: "2024-03-01",
                days: 5,
                status: "Completed",
            },
            {
                id: "LEAVE2002",
                type: "Sick Leave",
                startDate: "2024-01-08",
                endDate: "2024-01-09",
                days: 2,
                status: "Completed",
            },
            {
                id: "LEAVE2003",
                type: "Sick Leave",
                startDate: "2024-03-15",
                endDate: "2024-03-16",
                days: 1.5,
                status: "Completed",
                note: "Half day on the second day",
            },
        ],
        leaveHistoryYTDDays: 8.5,
        leaveHistoryYTDIncidents: 3,
        leaveHistoryYTDLongest: 5,
        leaveHistoryPrevYear: [
            {
                id: "LEAVE1901",
                type: "Annual Leave",
                startDate: "2023-08-21",
                endDate: "2023-09-01",
                days: 10,
                status: "Completed",
            },
            {
                id: "LEAVE1902",
                type: "Sick Leave",
                startDate: "2023-10-12",
                endDate: "2023-10-16",
                days: 5,
                status: "Completed",
            },
        ],
        leaveHistoryPrevYearDays: 15,
        leaveHistoryPrevYearIncidents: 2,
        leaveBreakdown: {
            "Annual Leave": 10,
            "Sick Leave": 5,
            Other: 0,
        },
    },
    {
        employeeId: "EMP003",
        firstName: "James",
        lastName: "Wilson",
        middleName: "Thomas",
        fullName: "James Thomas Wilson",
        gender: "Male",
        dateOfBirth: "1995-12-10",
        age: 28,
        civilStatus: "Single",
        contactNumber: "+1 (555) 345-6789",
        email: "james.wilson@company.com",
        currentAddress: "789 Pine Rd, Elsewhere, ST 13579",
        permanentAddress: "789 Pine Rd, Elsewhere, ST 13579",
        nationality: "Canadian",
        emergencyName: "Emma Wilson",
        emergencyNumber: "+1 (555) 765-4321",
        emergencyRelation: "Sister",
        dateHired: "2022-01-15",
        dateRegularized: null,
        employmentStatus: "Probationary",
        workArrangement: "On-site",
        companyName: "Tech Solutions Inc.",
        businessUnit: "Sales",
        department: "Business Development",
        position: "Sales Representative",
        reportingManager: "Robert Taylor",
        employeeType: "Full-time",
        endDate: null,
        terminationReason: null,
        lengthOfService: "1 year 11 months",
        basicSalary: 75000,
        salaryType: "Monthly",
        payFrequency: "Semi-Monthly",
        hourlyRate: 1291.43,
        dailyRate: 3571.43,
        monthlyRate: 75000,
        annualSalary: 900000,
        overtimePay: 0,
        nightDifferential: 0,
        holidayPay: 0,
        restDayPay: 0,
        hazardPay: 0,
        otherEarnings: 5000,
        grossPay: 80000,
        taxableIncome: 75000,
        withHoldingTax: 15000,
        netPay: 65000,
        thirteenthMonth: 75000,
        bonus: 150000,
        loanDeduction: 5000,
        advancesDeduction: 0,
        otherDeductions: 2000,
        totalLeaveBalance: 40,
        leaveTypeBreakdown: {
            "Sick Leave": 10,
            "Vacation Leave": 10,
            "Leave Type 3": 10,
            "Leave Type 4": 10,
        },
        totalLeaveBalanceTransactions: [
            {
                date: "2024-03-01",
                type: "Credit",
                amount: "+15",
                balance: "18",
            },
            {
                date: "2024-02-15",
                type: "Debit",
                amount: "-5",
                balance: "10",
            },
            {
                date: "2024-01-01",
                type: "Credit",
                amount: "+15",
                balance: "15",
            },
        ],
        totalLeaveTransactions: [
            {
                id: "TRX001",
                date: "2024-03-15",
                type: "Credit",
                leaveType: "Annual Leave",
                description: "Monthly accrual",
                amount: 1.67,
                balance: 41.67,
                status: "Completed",
                approvedBy: "System",
                requestDate: "2024-03-01",
            },
            {
                id: "TRX002",
                date: "2024-03-10",
                type: "Debit",
                leaveType: "Sick Leave",
                description: "Medical appointment",
                amount: -1,
                balance: 40,
                status: "Approved",
                approvedBy: "Sarah Wilson",
                requestDate: "2024-03-05",
            },
            {
                id: "TRX003",
                date: "2024-02-15",
                type: "Credit",
                leaveType: "Annual Leave",
                description: "Monthly accrual",
                amount: 1.67,
                balance: 41,
                status: "Completed",
                approvedBy: "System",
                requestDate: "2024-02-01",
            },
            {
                id: "TRX004",
                date: "2024-02-05",
                type: "Debit",
                leaveType: "Annual Leave",
                description: "Family vacation",
                amount: -5,
                balance: 39.33,
                status: "Approved",
                approvedBy: "Sarah Wilson",
                requestDate: "2024-01-20",
            },
        ],
        annualLeaveTransactions: [
            {
                id: "ALTRX001",
                date: "2024-03-15",
                type: "Credit",
                description: "Monthly accrual",
                amount: 1.67,
                balance: 11.67,
            },
            {
                id: "ALTRX002",
                date: "2024-02-15",
                type: "Credit",
                description: "Monthly accrual",
                amount: 1.67,
                balance: 10,
            },
            {
                id: "ALTRX003",
                date: "2024-02-05",
                type: "Debit",
                description: "Family vacation",
                amount: -5,
                balance: 8.33,
            },
        ],
        sickLeaveTransactions: [
            {
                id: "SLTRX001",
                date: "2024-03-10",
                type: "Debit",
                description: "Medical appointment",
                amount: -1,
                balance: 9,
            },
            {
                id: "SLTRX002",
                date: "2024-01-15",
                type: "Credit",
                description: "Annual reset",
                amount: 10,
                balance: 10,
            },
        ],
        sickLeaveBalance: 6,
        vacationLeaveBalance: 8,
        emergencyLeaveBalance: 3,
        maternityLeaveBalance: 0,
        paternityLeaveBalance: 7,
        bereavementLeaveBalance: 3,
        birthdayLeaveBalance: 1,
        specialLeaveBalance: 3,
        leaveType: "Sick Leave",
        leaveStatus: "Approved",
        leaveStartDate: "2024-02-12",
        leaveEndDate: "2024-02-13",
        leaveDuration: 2,
        leaveReason: "Medical appointment and recovery",
        leaveUsedYTD: 10,
        leaveBreakdown: {
            "Annual Leave": 6,
            "Sick Leave": 4,
        },
    },
    {
        employeeId: "EMP004",
        firstName: "Sarah",
        lastName: "Chen",
        middleName: "Li",
        fullName: "Sarah Li Chen",
        gender: "Female",
        dateOfBirth: "1992-08-20",
        age: 31,
        civilStatus: "Single",
        contactNumber: "+1 (555) 456-7890",
        email: "sarah.chen@company.com",
        currentAddress: "321 Maple St, Elsewhere, ST 24680",
        permanentAddress: "321 Maple St, Elsewhere, ST 24680",
        nationality: "Chinese",
        emergencyName: "Li Wei Chen",
        emergencyNumber: "+1 (555) 654-3210",
        emergencyRelation: "Father",
        dateHired: "2021-04-01",
        dateRegularized: "2021-10-01",
        employmentStatus: "Regular",
        workArrangement: "Remote",
        companyName: "Tech Solutions Inc.",
        businessUnit: "Technology",
        department: "Engineering",
        position: "Software Engineer",
        reportingManager: "Sarah Wilson",
        employeeType: "Full-time",
        endDate: null,
        terminationReason: null,
        lengthOfService: "2 years 8 months",
        basicSalary: 65000,
        salaryType: "Monthly",
        payFrequency: "Semi-Monthly",
        hourlyRate: 386.9,
        dailyRate: 3095.24,
        monthlyRate: 65000,
        annualSalary: 780000,
        overtimePay: 0,
        nightDifferential: 0,
        holidayPay: 0,
        restDayPay: 0,
        hazardPay: 0,
        otherEarnings: 5000,
        grossPay: 80000,
        taxableIncome: 75000,
        withHoldingTax: 15000,
        netPay: 65000,
        thirteenthMonth: 75000,
        bonus: 150000,
        loanDeduction: 5000,
        advancesDeduction: 0,
        otherDeductions: 2000,
        totalLeaveBalance: 40,
        leaveTypeBreakdown: {
            "Sick Leave": 10,
            "Vacation Leave": 10,
            "Leave Type 3": 10,
            "Leave Type 4": 10,
        },
        totalLeaveBalanceTransactions: [
            {
                date: "2024-02-01",
                type: "Credit",
                amount: "+15",
                balance: "22",
            },
            {
                date: "2024-01-15",
                type: "Debit",
                amount: "-3",
                balance: "7",
            },
            {
                date: "2024-01-01",
                type: "Credit",
                amount: "+10",
                balance: "10",
            },
        ],
        totalLeaveTransactions: [
            {
                id: "TRX001",
                date: "2024-03-15",
                type: "Credit",
                leaveType: "Annual Leave",
                description: "Monthly accrual",
                amount: 1.67,
                balance: 41.67,
                status: "Completed",
                approvedBy: "System",
                requestDate: "2024-03-01",
            },
            {
                id: "TRX002",
                date: "2024-03-10",
                type: "Debit",
                leaveType: "Sick Leave",
                description: "Medical appointment",
                amount: -1,
                balance: 40,
                status: "Approved",
                approvedBy: "Sarah Wilson",
                requestDate: "2024-03-05",
            },
            {
                id: "TRX003",
                date: "2024-02-15",
                type: "Credit",
                leaveType: "Annual Leave",
                description: "Monthly accrual",
                amount: 1.67,
                balance: 41,
                status: "Completed",
                approvedBy: "System",
                requestDate: "2024-02-01",
            },
            {
                id: "TRX004",
                date: "2024-02-05",
                type: "Debit",
                leaveType: "Annual Leave",
                description: "Family vacation",
                amount: -5,
                balance: 39.33,
                status: "Approved",
                approvedBy: "Sarah Wilson",
                requestDate: "2024-01-20",
            },
        ],
        annualLeaveTransactions: [
            {
                id: "ALTRX001",
                date: "2024-03-15",
                type: "Credit",
                description: "Monthly accrual",
                amount: 1.67,
                balance: 11.67,
            },
            {
                id: "ALTRX002",
                date: "2024-02-15",
                type: "Credit",
                description: "Monthly accrual",
                amount: 1.67,
                balance: 10,
            },
            {
                id: "ALTRX003",
                date: "2024-02-05",
                type: "Debit",
                description: "Family vacation",
                amount: -5,
                balance: 8.33,
            },
        ],
        sickLeaveTransactions: [
            {
                id: "SLTRX001",
                date: "2024-03-10",
                type: "Debit",
                description: "Medical appointment",
                amount: -1,
                balance: 9,
            },
            {
                id: "SLTRX002",
                date: "2024-01-15",
                type: "Credit",
                description: "Annual reset",
                amount: 10,
                balance: 10,
            },
        ],
        sickLeaveBalance: 8,
        vacationLeaveBalance: 10,
        emergencyLeaveBalance: 3,
        maternityLeaveBalance: 0,
        paternityLeaveBalance: 7,
        bereavementLeaveBalance: 3,
        birthdayLeaveBalance: 1,
        specialLeaveBalance: 5,
        leaveType: "Vacation Leave",
        leaveStatus: "Approved",
        leaveStartDate: "2024-03-25",
        leaveEndDate: "2024-03-29",
        leaveDuration: 5,
        leaveReason: "Annual family vacation",
        leaveUsedYTD: 12,
        leaveBreakdown: {
            "Annual Leave": 8,
            "Sick Leave": 4,
        },
    },
    {
        employeeId: "EMP005",
        firstName: "Michael",
        lastName: "Rodriguez",
        middleName: "Jose",
        fullName: "Michael Jose Rodriguez",
        gender: "Male",
        dateOfBirth: "1987-03-15",
        age: 36,
        civilStatus: "Married",
        contactNumber: "+1 (555) 567-8901",
        email: "michael.rodriguez@company.com",
        currentAddress: "567 Oak Lane, Somewhere, ST 13579",
        permanentAddress: "567 Oak Lane, Somewhere, ST 13579",
        nationality: "Mexican",
        emergencyName: "Ana Rodriguez",
        emergencyNumber: "+1 (555) 789-0123",
        emergencyRelation: "Spouse",
        dateHired: "2018-07-15",
        dateRegularized: "2019-01-15",
        employmentStatus: "Regular",
        workArrangement: "Hybrid",
        companyName: "Tech Solutions Inc.",
        businessUnit: "Sales",
        department: "Sales",
        position: "Senior Sales Manager",
        reportingManager: "Robert Taylor",
        employeeType: "Full-time",
        endDate: null,
        terminationReason: null,
        lengthOfService: "5 years 5 months",
        basicSalary: 85000,
        salaryType: "Monthly",
        payFrequency: "Semi-Monthly",
        hourlyRate: 505.95,
        dailyRate: 4047.62,
        monthlyRate: 85000,
        annualSalary: 1020000,
        overtimePay: 0,
        nightDifferential: 0,
        holidayPay: 0,
        restDayPay: 0,
        hazardPay: 0,
        otherEarnings: 5000,
        grossPay: 80000,
        taxableIncome: 75000,
        withHoldingTax: 15000,
        netPay: 65000,
        thirteenthMonth: 75000,
        bonus: 150000,
        loanDeduction: 5000,
        advancesDeduction: 0,
        otherDeductions: 2000,
        totalLeaveBalance: 40,
        leaveTypeBreakdown: {
            "Sick Leave": 10,
            "Vacation Leave": 10,
            "Leave Type 3": 10,
            "Leave Type 4": 10,
        },
        totalLeaveBalanceTransactions: [
            {
                date: "2024-02-01",
                type: "Credit",
                amount: "+20",
                balance: "30",
            },
            {
                date: "2024-01-15",
                type: "Debit",
                amount: "-5",
                balance: "10",
            },
            {
                date: "2024-01-01",
                type: "Credit",
                amount: "+15",
                balance: "15",
            },
        ],
        totalLeaveTransactions: [
            {
                id: "TRX001",
                date: "2024-03-15",
                type: "Credit",
                leaveType: "Annual Leave",
                description: "Monthly accrual",
                amount: 1.67,
                balance: 41.67,
                status: "Completed",
                approvedBy: "System",
                requestDate: "2024-03-01",
            },
            {
                id: "TRX002",
                date: "2024-03-10",
                type: "Debit",
                leaveType: "Sick Leave",
                description: "Medical appointment",
                amount: -1,
                balance: 40,
                status: "Approved",
                approvedBy: "Sarah Wilson",
                requestDate: "2024-03-05",
            },
            {
                id: "TRX003",
                date: "2024-02-15",
                type: "Credit",
                leaveType: "Annual Leave",
                description: "Monthly accrual",
                amount: 1.67,
                balance: 41,
                status: "Completed",
                approvedBy: "System",
                requestDate: "2024-02-01",
            },
            {
                id: "TRX004",
                date: "2024-02-05",
                type: "Debit",
                leaveType: "Annual Leave",
                description: "Family vacation",
                amount: -5,
                balance: 39.33,
                status: "Approved",
                approvedBy: "Sarah Wilson",
                requestDate: "2024-01-20",
            },
        ],
        annualLeaveTransactions: [
            {
                id: "ALTRX001",
                date: "2024-03-15",
                type: "Credit",
                description: "Monthly accrual",
                amount: 1.67,
                balance: 11.67,
            },
            {
                id: "ALTRX002",
                date: "2024-02-15",
                type: "Credit",
                description: "Monthly accrual",
                amount: 1.67,
                balance: 10,
            },
            {
                id: "ALTRX003",
                date: "2024-02-05",
                type: "Debit",
                description: "Family vacation",
                amount: -5,
                balance: 8.33,
            },
        ],
        sickLeaveTransactions: [
            {
                id: "SLTRX001",
                date: "2024-03-10",
                type: "Debit",
                description: "Medical appointment",
                amount: -1,
                balance: 9,
            },
            {
                id: "SLTRX002",
                date: "2024-01-15",
                type: "Credit",
                description: "Annual reset",
                amount: 10,
                balance: 10,
            },
        ],
        sickLeaveBalance: 10,
        vacationLeaveBalance: 12,
        emergencyLeaveBalance: 3,
        maternityLeaveBalance: 105,
        paternityLeaveBalance: 0,
        bereavementLeaveBalance: 3,
        birthdayLeaveBalance: 1,
        specialLeaveBalance: 7,
        leaveType: "Maternity Leave",
        leaveStatus: "Pending",
        leaveStartDate: "2024-06-15",
        leaveEndDate: "2024-09-28",
        leaveDuration: 105,
        leaveReason: "Maternity leave for first child",
        leaveUsedYTD: 15,
        leaveRemaining: 17.5,
        leaveAccrualRate: 1.67,
        nextScheduledLeave: "2024-06-10",
        annualLeaveBalance: 13,
        annualLeaveEntitlement: 20,
        annualLeaveUsed: 10,
        annualLeaveRemaining: 10,
        annualLeaveRequested: 3,
        annualLeaveAccrued: 6,
        annualLeaveExpiry: "2024-12-31",
        sickLeaveEntitlement: 15,
        sickLeaveUsed: 5.5,
        sickLeaveRemaining: 9.5,
        sickLeaveDocumentation: true,
        sickLeaveIncidents: 3,
        maternityLeaveEntitlement: 90,
        maternityLeaveUsed: 0,
        maternityLeaveRemaining: 90,
        maternityLeaveStartDate: null,
        maternityLeaveEndDate: null,
        paternityLeaveEntitlement: 10,
        paternityLeaveUsed: 2.5,
        paternityLeaveRemaining: 7.5,
        bereavementLeaveEntitlement: 5,
        bereavementLeaveUsed: 0,
        bereavementLeaveRemaining: 5,
        pendingRequests: [
            {
                id: "REQ2001",
                type: "Annual Leave",
                startDate: "2024-06-10",
                endDate: "2024-06-12",
                days: 3,
                status: "Pending",
                requestedOn: "2024-04-15",
            },
        ],
        pendingRequestsCount: 1,
        pendingRequestsDays: 3,
        pendingRequestsEarliestDate: "2024-06-10",
        approvedRequests: [
            {
                id: "REQ1901",
                type: "Annual Leave",
                startDate: "2024-02-26",
                endDate: "2024-03-01",
                days: 5,
                status: "Approved",
                requestedOn: "2024-01-15",
                approvedOn: "2024-01-16",
                approvedBy: "Michael Brown",
            },
            {
                id: "REQ1801",
                type: "Sick Leave",
                startDate: "2024-01-08",
                endDate: "2024-01-09",
                days: 2,
                status: "Approved",
                requestedOn: "2024-01-08",
                approvedOn: "2024-01-10",
                approvedBy: "Michael Brown",
            },
        ],
        approvedRequestsCount: 2,
        approvedRequestsDays: 7,
        approvedRequestsNextDate: "2024-02-26",
        deniedRequests: [],
        deniedRequestsCount: 0,
        deniedRequestsDays: 0,
        leaveHistoryYTD: [
            {
                id: "LEAVE2001",
                type: "Annual Leave",
                startDate: "2024-02-26",
                endDate: "2024-03-01",
                days: 5,
                status: "Completed",
            },
            {
                id: "LEAVE2002",
                type: "Sick Leave",
                startDate: "2024-01-08",
                endDate: "2024-01-09",
                days: 2,
                status: "Completed",
            },
            {
                id: "LEAVE2003",
                type: "Sick Leave",
                startDate: "2024-03-15",
                endDate: "2024-03-16",
                days: 1.5,
                status: "Completed",
                note: "Half day on the second day",
            },
        ],
        leaveHistoryYTDDays: 8.5,
        leaveHistoryYTDIncidents: 3,
        leaveHistoryYTDLongest: 5,
        leaveHistoryPrevYear: [
            {
                id: "LEAVE1901",
                type: "Annual Leave",
                startDate: "2023-08-21",
                endDate: "2023-09-01",
                days: 10,
                status: "Completed",
            },
            {
                id: "LEAVE1902",
                type: "Sick Leave",
                startDate: "2023-10-12",
                endDate: "2023-10-16",
                days: 5,
                status: "Completed",
            },
        ],
        leaveHistoryPrevYearDays: 15,
        leaveHistoryPrevYearIncidents: 2,
        leaveBreakdown: {
            "Annual Leave": 7,
            "Sick Leave": 3,
            "Paternity Leave": 2.5,
        },
    },
    {
        employeeId: "EMP006",
        firstName: "Emily",
        lastName: "Thompson",
        middleName: "Grace",
        fullName: "Emily Grace Thompson",
        gender: "Female",
        dateOfBirth: "1993-11-30",
        age: 30,
        civilStatus: "Single",
        contactNumber: "+1 (555) 678-9012",
        email: "emily.thompson@company.com",
        currentAddress: "789 Pine Court, Elsewhere, ST 97531",
        permanentAddress: "789 Pine Court, Elsewhere, ST 97531",
        nationality: "British",
        emergencyName: "George Thompson",
        emergencyNumber: "+1 (555) 890-1234",
        emergencyRelation: "Father",
        dateHired: "2022-09-01",
        dateRegularized: "2023-03-01",
        employmentStatus: "Regular",
        workArrangement: "On-site",
        companyName: "Tech Solutions Inc.",
        businessUnit: "Technology",
        department: "Engineering",
        position: "QA Engineer",
        reportingManager: "Sarah Wilson",
        employeeType: "Full-time",
        endDate: null,
        terminationReason: null,
        lengthOfService: "1 year 3 months",
        basicSalary: 60000,
        salaryType: "Monthly",
        payFrequency: "Semi-Monthly",
        hourlyRate: 357.14,
        dailyRate: 2857.14,
        monthlyRate: 60000,
        annualSalary: 720000,
        overtimePay: 0,
        nightDifferential: 0,
        holidayPay: 0,
        restDayPay: 0,
        hazardPay: 0,
        otherEarnings: 5000,
        grossPay: 80000,
        taxableIncome: 75000,
        withHoldingTax: 15000,
        netPay: 65000,
        thirteenthMonth: 75000,
        bonus: 150000,
        loanDeduction: 5000,
        advancesDeduction: 0,
        otherDeductions: 2000,
        totalLeaveBalance: 40,
        leaveTypeBreakdown: {
            "Sick Leave": 10,
            "Vacation Leave": 10,
            "Leave Type 3": 10,
            "Leave Type 4": 10,
        },
        totalLeaveBalanceTransactions: [
            {
                date: "2024-02-01",
                type: "Credit",
                amount: "+10",
                balance: "15",
            },
            {
                date: "2024-01-15",
                type: "Debit",
                amount: "-2",
                balance: "5",
            },
            {
                date: "2024-01-01",
                type: "Credit",
                amount: "+7",
                balance: "7",
            },
        ],
        totalLeaveTransactions: [
            {
                id: "TRX001",
                date: "2024-03-15",
                type: "Credit",
                leaveType: "Annual Leave",
                description: "Monthly accrual",
                amount: 1.67,
                balance: 41.67,
                status: "Completed",
                approvedBy: "System",
                requestDate: "2024-03-01",
            },
            {
                id: "TRX002",
                date: "2024-03-10",
                type: "Debit",
                leaveType: "Sick Leave",
                description: "Medical appointment",
                amount: -1,
                balance: 40,
                status: "Approved",
                approvedBy: "Sarah Wilson",
                requestDate: "2024-03-05",
            },
            {
                id: "TRX003",
                date: "2024-02-15",
                type: "Credit",
                leaveType: "Annual Leave",
                description: "Monthly accrual",
                amount: 1.67,
                balance: 41,
                status: "Completed",
                approvedBy: "System",
                requestDate: "2024-02-01",
            },
            {
                id: "TRX004",
                date: "2024-02-05",
                type: "Debit",
                leaveType: "Annual Leave",
                description: "Family vacation",
                amount: -5,
                balance: 39.33,
                status: "Approved",
                approvedBy: "Sarah Wilson",
                requestDate: "2024-01-20",
            },
        ],
        annualLeaveTransactions: [
            {
                id: "ALTRX001",
                date: "2024-03-15",
                type: "Credit",
                description: "Monthly accrual",
                amount: 1.67,
                balance: 11.67,
            },
            {
                id: "ALTRX002",
                date: "2024-02-15",
                type: "Credit",
                description: "Monthly accrual",
                amount: 1.67,
                balance: 10,
            },
            {
                id: "ALTRX003",
                date: "2024-02-05",
                type: "Debit",
                description: "Family vacation",
                amount: -5,
                balance: 8.33,
            },
        ],
        sickLeaveTransactions: [
            {
                id: "SLTRX001",
                date: "2024-03-10",
                type: "Debit",
                description: "Medical appointment",
                amount: -1,
                balance: 9,
            },
            {
                id: "SLTRX002",
                date: "2024-01-15",
                type: "Credit",
                description: "Annual reset",
                amount: 10,
                balance: 10,
            },
        ],
        sickLeaveBalance: 6,
        vacationLeaveBalance: 8,
        emergencyLeaveBalance: 3,
        maternityLeaveBalance: 0,
        paternityLeaveBalance: 7,
        bereavementLeaveBalance: 3,
        birthdayLeaveBalance: 1,
        specialLeaveBalance: 3,
        leaveType: "Sick Leave",
        leaveStatus: "Approved",
        leaveStartDate: "2024-02-12",
        leaveEndDate: "2024-02-13",
        leaveDuration: 2,
        leaveReason: "Medical appointment and recovery",
        leaveUsedYTD: 10,
        leaveBreakdown: {
            "Annual Leave": 6,
            "Sick Leave": 4,
        },
    },
];

// Example of hierarchical data structure
export const hierarchicalEmployees = [
    {
        id: "dept1",
        employeeId: "DEPT1",
        firstName: "Engineering",
        lastName: "Department",
        fullName: "Engineering Department",
        isAggregated: true,
        totalLeaveBalance: 40,
        leaveTypeBreakdown: {
            "Sick Leave": 10,
            "Vacation Leave": 10,
            "Leave Type 3": 10,
            "Leave Type 4": 10,
        },

        leaveUsedYTD: 45,
        leaveBreakdown: {
            "Annual Leave": 30,
            "Sick Leave": 15,
        },
    },
    {
        id: "emp001",
        parentId: "dept1",
        employeeId: "EMP001",
        firstName: "John",
        lastName: "Doe",
        fullName: "John Doe",
        totalLeaveBalance: 37.5,
        leaveUsedYTD: 12.5,
        leaveBreakdown: {
            "Annual Leave": 7,
            "Sick Leave": 3,
            "Paternity Leave": 2.5,
        },
    },
    {
        id: "emp002",
        parentId: "dept1",
        employeeId: "EMP002",
        firstName: "Maria",
        lastName: "Garcia",
        fullName: "Maria Garcia",
        totalLeaveBalance: 32.5,
        leaveUsedYTD: 15,
        leaveBreakdown: {
            "Annual Leave": 10,
            "Sick Leave": 5,
            Other: 0,
        },
    },
    {
        id: "dept2",
        employeeId: "DEPT2",
        firstName: "Sales",
        lastName: "Department",
        fullName: "Sales Department",
        isAggregated: true,
        totalLeaveBalance: 85,
        leaveUsedYTD: 30,
        leaveBreakdown: {
            "Annual Leave": 20,
            "Sick Leave": 10,
        },
    },
    {
        id: "emp003",
        parentId: "dept2",
        employeeId: "EMP003",
        firstName: "James",
        lastName: "Wilson",
        fullName: "James Wilson",
        totalLeaveBalance: 18,
        leaveUsedYTD: 10,
        leaveBreakdown: {
            "Annual Leave": 6,
            "Sick Leave": 4,
        },
    },
];
